module.exports = __webpack_public_path__ + "img/qdzx.7496015f.png";